import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../../../../../chronusStore/helper";
import { leftNavActions } from "../../../../../chronusStore/slice/leftNav";
import { Collapse } from 'react-collapse';
import navigationEventTracker from "../tracker/navigationEventTracker";
import Badge from "../../../../generic/Utils/Badge";


const AdvanceNavItem = ({ tabId, label, iconClass, active, trackingInfo, displayOptions, subTabs, tabHtmlId, tabClass, badgeInfo }) => {

  const dispatch = useDispatch();

  const [expand, setExpand] = useState(false);

  const expandedTabId = useSelector((state) => state.leftNav.expandedTabId);

  const toggleExpand = (skipDispatch) => {
    if (!expand && !skipDispatch){
      navigationEventTracker(trackingInfo);
      dispatch(leftNavActions.updateExpandedTabId({ tabId: tabId }));
    }
    setExpand(!expand);
  };

  const redirectToSubTab = (subTabTrackingData) => {
    navigationEventTracker(subTabTrackingData);
  };

  const isBadgeInfoPresent = (badgeInfo) => badgeInfo && badgeInfo.text != (undefined || null)

  useEffect(() => { if (active) toggleExpand(true) }, [active]);
  useEffect(() => { if (expandedTabId && expandedTabId !== tabId) setExpand(false); }, [expandedTabId]);

  return (
    <div  id={tabHtmlId} className={ `${tabClass} `+ (displayOptions.hideOnWeb ? getDisplayOptions.hiddenOnWeb : displayOptions.hideOnMobile ? getDisplayOptions.hiddenOnMobileBlock : "")}>
      <div tabIndex={0} aria-expanded={expand ? true: false} role="button" className="navitem cjs_navigation_header collapsed" onClick={() => {toggleExpand()}}>
        <i className={`fa-regular fa-lg fa-fw ${iconClass}`}></i>
        <span className="nav-title">{label}</span>
        <div className="nav-badge">{isBadgeInfoPresent(badgeInfo) && (<Badge typeClass={badgeInfo.htmlClass} text={badgeInfo.text} />)}</div>
        <i className={`fa-regular ${expand ? "fa-angle-up" : "fa-angle-down"} ${isBadgeInfoPresent && 'ml-0'} expand-icon`}></i>
      </div>
      <Collapse  isOpened={expand} > <SubNavItems expand={expand} subTabs={subTabs} redirectToSubTab={redirectToSubTab} /> </Collapse>
    </div>
  );
};

const SubNavItems = ({ subTabs, expand, redirectToSubTab }) => {
  return subTabs.map((subNav, index) => <SubNavItem key={index} expand={expand} subNav={subNav} redirectToSubTab={redirectToSubTab}/>);
}

const SubNavItem = ({ subNav, expand, redirectToSubTab }) => {
  return (
    <>
      <a
        tabIndex={expand ? 0 : -1}
        className={`subnav-item ${subNav.active ? "navitem-active" : ""} ${subNav.tabClass ? subNav.tabClass : ""}`}
        href={subNav.url}
        onClick={() => redirectToSubTab(subNav.trackingInfo)}
        target={subNav.target}
      >
        <span className="subnav-title">{subNav.label}</span>
        <div className="nav-badge">{subNav.badgeInfo && subNav.badgeInfo.text != (undefined || null) && (<Badge typeClass={subNav.badgeInfo.htmlClass} text={subNav.badgeInfo.text} />)}</div>
      </a>
    </>
      )
}

export default AdvanceNavItem;
